import { render, staticRenderFns } from "./PointMaker.vue?vue&type=template&id=7365ab20&scoped=true"
import script from "./PointMaker.vue?vue&type=script&lang=js"
export * from "./PointMaker.vue?vue&type=script&lang=js"
import style0 from "./PointMaker.vue?vue&type=style&index=0&id=7365ab20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365ab20",
  null
  
)

export default component.exports